export function initHotJar (key) {
  const h = window
  const o = document
  const t = '//static.hotjar.com/c/hotjar-'
  const j = '.js?sv='

  h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) }
  h._hjSettings = { hjid: key, hjsv: 5 }
  let a = o.getElementsByTagName('head')[0]
  let r = o.createElement('script'); r.async = 1
  r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
  a.appendChild(r)
};



// WEBPACK FOOTER //
// ./src/util/analytics/HotJar.js